/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import withResponsiveWrapper from '../../../decorators/withResponsiveWrapper';
import Grid from '../../../components/Grid/Grid';
import List from '../../../components/List/List';
import Skeleton from '../../../components/Skeleton/Skeleton';
import basketStyle from '../Basket.scss';
import s from './BasketSkeleton.scss';

const INPUT_HEIGHT = '38px';

const BasketItemSkeleton = ({ isMobile }) => {
  return (
    <List item component="li" className={cx(basketStyle.panel)}>
      <div className={basketStyle.body}>
        <Grid container className={basketStyle.container}>
          <Grid item xs={12} sm md={6} className={basketStyle['item-title']}>
            <div
              className={cx(
                basketStyle.field,
                basketStyle['field--first-child'],
              )}
            >
              <div className={cx(basketStyle.head, 'hidden-sm', s.head)}>
                <Skeleton width="70px" height="23.1px" />
              </div>
              <div className={cx(basketStyle.content, s.justifySpaceBetween)}>
                <div className={s.fee}>
                  <Skeleton width="115px" height="20px" />
                </div>
                <div className="hidden-sm">
                  <Skeleton width="100px" height="70px" />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs sm={24} md={4} className={basketStyle['item-quantity']}>
            <div className={basketStyle.field}>
              <div
                className={cx(
                  basketStyle.head,
                  basketStyle.field__title,
                  'hidden-xs',
                  s.head,
                )}
              >
                <Skeleton width="70px" height="23.1px" />
              </div>
              <div
                className={cx(basketStyle.content, basketStyle.field__input)}
              >
                <Skeleton
                  width={isMobile ? '100%' : '84px'}
                  height={INPUT_HEIGHT}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs="auto" md={1} className={basketStyle['item-delete']}>
            <div className={cx(basketStyle.head, 'hidden-sm', s.head)}>
              <span style={{ visibility: 'hidden' }}>Delete</span>
            </div>
            <div
              className={cx(basketStyle.content, basketStyle['basket-delete'])}
            >
              <Skeleton circle width="30px" height="30px" />
            </div>
          </Grid>
          <Grid item xs={24} md={5} className={basketStyle['item-amount']}>
            <div className={basketStyle.field}>
              <div
                className={cx(
                  basketStyle.head,
                  basketStyle.field__title,
                  s.head,
                )}
              >
                <Skeleton width="70px" height="23.1px" />
              </div>
              <div
                className={cx(basketStyle.content, basketStyle.field__input)}
              >
                <Skeleton width="100%" height={INPUT_HEIGHT} />
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={24}
            md={2}
            lg={2}
            className={basketStyle['item-price']}
          >
            <div className={cx(basketStyle.field, s.justifySpaceBetween)}>
              <div className={cx(basketStyle.head, s.head)}>
                <Skeleton width="70px" height="23.1px" />
              </div>
              <div className={cx(basketStyle.content, s.noGrow)}>
                <Skeleton width="50px" height={INPUT_HEIGHT} />
              </div>
            </div>
          </Grid>
          <Grid item xs={24} md={6} className={basketStyle['item-delivery']}>
            <div className={basketStyle.field}>
              <div className={cx(basketStyle.head, 'hidden-sm', s.head)}>
                <Skeleton width="70px" height="23.1px" />
              </div>
              <div
                className={cx(
                  basketStyle.content,
                  basketStyle['content--delivery'],
                  s.delivery,
                )}
              >
                <List
                  container
                  direction="column"
                  spacing={4}
                  size="caption"
                  className={basketStyle['item-delivery__list']}
                >
                  <List item component="li">
                    <Skeleton height="17px" />
                  </List>
                  <List item component="li">
                    <Skeleton height="17px" />
                  </List>
                  <List item component="li">
                    <Skeleton width="55px" height="17px" />
                  </List>
                  <List
                    item
                    component="li"
                    className={basketStyle['item-delivery__edit']}
                  >
                    <Skeleton width="40px" height="17px" />
                  </List>
                </List>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={24}
            className={cx(basketStyle.row, basketStyle['item-actions'])}
          >
            <List
              container
              direction="column"
              className={basketStyle['item-actions__list']}
              size="caption"
            >
              <List item component="li">
                <Grid
                  container
                  spacing={8}
                  alignItems="center"
                  justify={isMobile && 'space-between'}
                >
                  <Grid item xs md="auto">
                    <div className={s.terms}>
                      <Skeleton circle width="17px" height="17px" />
                      <Skeleton height="17px" />
                    </div>
                  </Grid>
                  <Grid item xs md="auto" className={cx(s.noGrow)}>
                    <Skeleton width="60px" height="17px" />
                  </Grid>
                </Grid>
              </List>
            </List>
          </Grid>
        </Grid>
      </div>

      <div className={cx(basketStyle.footer, s.footer)} />
    </List>
  );
};

BasketItemSkeleton.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default compose(
  withResponsiveWrapper(),
  withStyles(basketStyle, s),
)(BasketItemSkeleton);
